import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import AgencySettingsFactory from "../../Entity/Factories/AgencySettingsFactory";
import { AgencySettingsInterface } from "../../Entity/Entities/Settings/Agency/AgencySettingsInterface";

class AgencySettingsUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const agencySettings: AgencySettingsInterface = AgencySettingsFactory.create(props.res);
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_SUCCESS,
      payload: {
        settings: agencySettings
      }
    });

    // this.props.dispatch({
    //   type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    // })

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    });
  }

}

export { AgencySettingsUpdate };
